import '@/store/api/staff-member/typedefs'
import api from '@/store/api/staff-member'
import * as mutationTypes from './mutation-types'
import {map} from 'lodash'

const initialState = () => ({
    staffMember: {}
})

const state = initialState()

export default {
    namespaced: true,
    state,
    getters: {
        staffMember: state => {
            const staffMember = state.staffMember

            if (!staffMember.id) {
                return staffMember
            }

            return {
                ...staffMember,
                full_name: `${staffMember.first_name} ${staffMember.last_name}`,
                group_ids: map(staffMember.groups, 'id')
            }
        }
    },
    actions: {
        /**
         * @param {StaffMemberQuery} data
         * @returns {Promise<*>}
         */
        showStaffMember: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showStaffMember(data)
                commit(mutationTypes.SET_STAFF_MEMBER, response.user)
                return response.user
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {StaffMember} data
         * @returns {Promise<*>}
         */
        createStaffMember: async ({dispatch}, data) => {
            try {
                const response = await api.createStaffMember(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {StaffMember} data
         * @returns {Promise<*>}
         */
        updateStaffMember: async ({dispatch}, data) => {
            try {
                const response = await api.updateStaffMember(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{id: number}} data
         * @returns {Promise<*>}
         */
        deactivateStaffMember: async ({dispatch}, data) => {
            try {
                const response = await api.deactivateStaffMember(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{id: number}} data
         * @returns {Promise<*>}
         */
        deactivateStaffMemberSso: async ({dispatch}, data) => {
            try {
                const response = await api.deactivateStaffMemberSso(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{id: number}} data
         * @returns {Promise<*>}
         */
        requestSipcentricAccount: async ({dispatch}, data) => {
            try {
                const response = await api.requestSipcentricAccount(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{id: number}} data
         * @returns {Promise<*>}
         */
        sendSipcentricAccountDetails: async ({dispatch}, data) => {
            try {
                const response = await api.sendSipcentricAccountDetails(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{id: number}} data
         * @returns {Promise<undefined|*>}
         */
        sendSsoInvite: async ({dispatch}, data) => {
            try {
                const response = await api.sendSsoInvite(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{sso: {email_address: string}}} data
         * @returns {Promise<*>}
         */
        resendSsoInvite: async ({dispatch}, {sso}) => {
            try {
                const response = await api.resendSsoInvite(sso)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{sso: {email_address: string}}} data
         * @returns {Promise<*>}
         */
        cancelSsoInvite: async ({dispatch}, {sso}) => {
            try {
                const response = await api.cancelSsoInvite(sso)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{sso: {email_address: string}}} data
         * @returns {Promise<*>}
         */
        forcePasswordChange: async ({dispatch}, {sso}) => {
            try {
                const response = await api.forcePasswordChange(sso)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{sso: {email_address: string}}} data
         * @returns {Promise<*>}
         */
        removeMfa: async ({dispatch}, {sso}) => {
            try {
                const response = await api.removeMfa(sso)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{sso: {email_address: string}}} data
         * @returns {Promise<*>}
         */
        sendPasswordReset: async ({dispatch}, {sso}) => {
            try {
                const response = await api.sendPasswordReset(sso)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        setStaffMember: async ({commit}, data) => commit(mutationTypes.SET_STAFF_MEMBER, data),
        resetStaffMember: async ({commit}) => commit(mutationTypes.RESET_STAFF_MEMBER)
    },
    mutations: {
        [mutationTypes.SET_STAFF_MEMBER]: (state, data) => state.staffMember = data,
        [mutationTypes.RESET_STAFF_MEMBER]: (state) => Object.assign(state, initialState())
    }
}
